import css from "classnames";
import * as React from "react";

import { EventPointList } from "../Soccer/SoccerLive/model";

const styles = require("./styles.scss"); // tslint:disable-line no-var-requires

interface Props {
    data?: EventPointList[];
}

interface State {
    openPitch: boolean;
}

export default class BetGeniusScorePitch extends React.Component<Props, State> {
    constructor(props: Props) {
        super(props);
        this.state = { openPitch: true };
    }

    public render(): JSX.Element | null {
        const { data: eventList } = this.props;

        if (!eventList || eventList.length === 0) {
            return null;
        }

        // const pitchColumnCss = css(styles.pitchColumn,
        //                             eventList.length > 1 ? styles.arrow : "",
        //                             this.state.openPitch ? styles.up : "");

        const team1Event = eventList[0].evTeam1 ? (
            <span>
                {eventList[0].evTeam1} ({eventList[0].score})
            </span>
        ) : null;
        const team2Event = eventList[0].evTeam2 ? (
            <span className={css(styles.eventRight)}>
                {eventList[0].evTeam2} ({eventList[0].score})
            </span>
        ) : null;
        const scoreListCSS = css(
            styles.pitchContainer,
            this.state.openPitch ? "" : styles.hide
        );

        return (
            <section className={css(styles.scorePitch)}>
                <div className={css(styles.pitchRow, styles.topSection)}>
                    <div className={css(styles.pitchColumn, styles.pitchRight)}>
                        {team1Event}
                    </div>
                    <div className={css(styles.pitchSquare, styles.minute)}>
                        {eventList[0].minute}
                    </div>
                    <div className={css(styles.pitchColumn)}>{team2Event}</div>
                </div>
                <ul className={scoreListCSS}>
                    {this.renderScoreList(eventList)}
                </ul>
            </section>
        );
    }

    private renderScoreList(pointList: EventPointList[]) {
        const [, ...rest] = pointList.map((event, index) => {
            const pitchRowCSS = css(styles.pitchColumn, styles.pitchRight);
            const pitchColumnCss = css(styles.pitchSquare, styles.transparent);
            if (event.evTeam1 !== "" && event.isHt === false) {
                return (
                    <li key={index} className={styles.pitchRow}>
                        <div className={pitchRowCSS}>
                            {event.evTeam1} ({event.score})
                        </div>
                        <div className={styles.pitchSquare}>{event.minute}</div>
                        <div className={styles.pitchColumn}>
                            {event.evTeam2}
                        </div>
                    </li>
                );
            } else if (event.isHt === true) {
                return (
                    <li
                        key={index}
                        className={css(styles.pitchRow, styles.pitchHT)}
                    >
                        <div className={css(styles.pitchColumn)} />
                        <div className={pitchColumnCss}>{event.minute}</div>
                        <div className={css(styles.pitchColumn)} />
                    </li>
                );
            } else {
                return (
                    <li key={index} className={styles.pitchRow}>
                        <div className={pitchRowCSS}>{event.evTeam1}</div>
                        <div className={styles.pitchSquare}>{event.minute}</div>
                        <div className={styles.pitchColumn}>
                            {event.evTeam2} ({event.score})
                        </div>
                    </li>
                );
            }
        });

        return rest;
    }
}
